import React from 'react';

const P = {
  fontSize: '1.0625rem',
  lineHeight: 1.85,
  color: 'var(--gray)',
  marginBottom: '1.5rem',
  fontWeight: 300,
  maxWidth: '68ch'
};

// Secção · O peso da avaliação no novo processo (fundo claro)
export const HerancasRoleSection = () => (
  <section
    className="valuare-section"
    style={{ background: 'var(--cream)' }}
    data-testid="herancas-role-section"
  >
    <div className="valuare-section-content">
      <div style={{ maxWidth: '820px', margin: '0 auto', textAlign: 'left' }}>
        <div className="valuare-section-label">A Avaliação no Processo</div>
        <h2 className="valuare-section-title">
          Sem avaliação,<br />
          <em>o processo não avança</em>
        </h2>
        <p style={P}>
          Havendo acordo entre todos os herdeiros, a venda poderá avançar pelo preço acordado. Não
          existindo consenso, caberá ao tribunal fixar o preço-base a partir de avaliações
          independentes, podendo os herdeiros que discordem juntar avaliações alternativas. A
          avaliação deixa de ser um documento informal ou opcional e passa a constituir um elemento
          processual estruturante.
        </p>
        <p style={P}>
          O valor fixado tem consequências diretas. Determina o preço-base da venda em leilão
          eletrónico e, por essa via, condiciona o montante que virá a ser repartido pelos
          interessados e o preço pelo qual o imóvel poderá permanecer na esfera familiar. O imóvel
          não poderá ser vendido por valor inferior ao preço-base fixado, ainda que o tribunal possa
          determinar a sua redução faseada e repetir o procedimento caso o leilão fique deserto. Aos
          herdeiros e ao cônjuge meeiro é reconhecido o direito de remição, ou seja, a faculdade de
          adquirir o imóvel pelo preço efetivamente alcançado na venda, mesmo após redução do
          preço-base, com prevalência sobre direitos de preferência de terceiros. Um número mal
          fundamentado penaliza toda a partilha.
        </p>
        <p style={P}>
          Porque o processo pode ser desencadeado por um único interessado, a avaliação é também um
          instrumento de defesa. O herdeiro que se opõe à venda, ou que discorda do valor proposto,
          pode apresentar uma avaliação alternativa e devidamente fundamentada para influenciar o
          preço final.
        </p>
        <div
          style={{
            background: 'var(--white)',
            borderLeft: '3px solid var(--gold)',
            borderRadius: '0 6px 6px 0',
            padding: '26px 30px',
            marginTop: '2.5rem',
            maxWidth: '68ch'
          }}
          data-testid="herancas-role-callout"
        >
          <p style={{ fontSize: '1rem', lineHeight: 1.8, color: 'var(--navy)', margin: 0, fontWeight: 400 }}>
            Quando a diferença entre duas avaliações ultrapasse 20% do valor da avaliação mais
            baixa, será obrigatória uma terceira avaliação. Uma avaliação rigorosa e bem fundamentada
            é a melhor forma de evitar o custo e a demora de uma nova perícia.
          </p>
        </div>
      </div>
    </div>
  </section>
);
